import { useState } from 'react'
import dataSelectField from '@templates/AddNewItemModal/templates/dataSelectField'
import { useGetDangerEventsQuery } from '@services/dangerEvents'
import { UseDangerField } from '@app-types/riskMapFields'

const useDangerEventsField: UseDangerField = ({
  params,
  onOneItem,
  skip,
  initFilters,
}) => {
  const [filters, setFilters] = useState(initFilters)

  return {
    setFilters,
    field: (fieldParams) =>
      dataSelectField({
        query: useGetDangerEventsQuery,
        filters,
        setFilters,
        onOneItem,
        dropdownWidth: 500,
        label: 'Опасное событие',
        name: 'action',
        withManualEntryText: true,
        withShowLabelInDescription: true,
        skip,
        ...params,
        ...fieldParams,
      }),
  }
}

export default useDangerEventsField
